<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4 text-truncate">Add New Sublocation {{ (inputName) ? (" - " + this.inputName) : "" }}</h6>
        <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true" class="heading-small text-muted mb-4 text-truncate">View Sublocation - {{this.inputName}}</h6>
        <h6 v-else class="heading-small text-muted mb-4 text-truncate">Edit Sublocation - {{this.inputName}}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <b-tabs v-show="profileId != 0 && this.$attrs.viewMode == true" content-class="mt-3">
            <b-tab title="Details" active v-on:click="openDetails"></b-tab>
            <b-tab title="History" v-on:click="openHistory">
                <b><label>Created By: </label></b>
                {{inputCreatedBy  || "System" }} | {{inputCreatedAt | dateFilter}} 
                <br>
                <b><label>Updated By:</label></b>
                {{inputUpdatedBy  || "System" }} | {{inputUpdatedAt | dateFilter}} 
            </b-tab>
        </b-tabs>

        <form id="form-proper">
            <div v-if="customFormMode == 1" v-show="showDetails">
                <base-input alternative="" label="Code" placeholder="" v-model="inputCode" input-classes="form-control" />
                <base-input alternative="" label="Name" placeholder="" v-model="inputName" input-classes="form-control" required/>
                <base-input label="Type">
                    <select class="form-control form-control-sm" v-model="inputSublocationType">
                        <option v-for="option in sublocationTypeOptions" v-bind:value="option.key" v-bind:key="option.key">
                            {{option.value}}
                        </option>
                    </select>
                </base-input>
                <base-input label="Site" required>
                    <div class="form-group row">
                        <p class="ml-3" v-if="defaultSiteSublocation != ''" style="line-height: 90%;"><small>This is the default sublocation of Site: {{this.defaultSiteSublocation}}</small></p>
                        <div class="col-sm-6">
                            <input type="text" class="form-control" v-model="siteName" disabled>
                        </div>
                        <div class="col-sm-6">
                            <autocomplete
                                ref="autocomplete"
                                placeholder="Search Site"
                                :source="siteEndpoint"
                                input-class="form-control"
                                results-property="data"
                                :results-display="formattedDisplay"
                                :request-headers="authHeaders"
                                @selected="getSite"
                                :disableInput='isSiteDisabled'>
                            </autocomplete>
                        </div>
                    </div>
                </base-input>
                <base-input label="Salesman">
                    <div class="form-group row">
                        <div class="col-sm-6">
                            <input type="text" class="form-control" v-model="salesmanName" disabled>
                        </div>
                        <div class="col-sm-6">
                            <autocomplete
                                ref="autocomplete"
                                placeholder="Search Salesman"
                                :source="salesmanEndpoint"
                                input-class="form-control"
                                results-property="data"
                                :results-display="formattedDisplay"
                                :request-headers="authHeaders"
                                @selected="getSalesman">
                            </autocomplete>
                        </div>
                    </div>
                </base-input>            
                <base-input alternative="" label="Description">
                    <textarea rows="4" class="form-control" v-model="inputDescription"/>
                </base-input>
                <base-input alternative="" label="Tags">
                    <textarea rows="4" class="form-control" v-model="inputTags"/>
                </base-input>
            </div> 
            <div v-if="customFormMode == 2">
                <!-- Override -->
                <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups}" :formSettings="sublocation" @valueUpdated="updateSettings" :key="dynamicFormKey"/>
            </div>
            <div v-if="customFormMode == 3">
                <!-- Append -->
                <a-tabs defaultActiveKey="1">
                    <a-tab-pane tab="Basic" key="1">
                        <base-input alternative="" label="Code" placeholder="" v-model="inputCode" input-classes="form-control" />
                        <base-input alternative="" label="Name" placeholder="" v-model="inputName" input-classes="form-control" required/>
                        <base-input label="Type">
                            <select class="form-control form-control-sm" v-model="inputSublocationType">
                                <option v-for="option in sublocationTypeOptions" v-bind:value="option.key" v-bind:key="option.key">
                                    {{option.value}}
                                </option>
                            </select>
                        </base-input>
                        <base-input label="Site" required>
                            <div class="form-group row">
                                <p class="ml-3" v-if="defaultSiteSublocation != ''" style="line-height: 90%;"><small>This is the default sublocation of Site: {{this.defaultSiteSublocation}}</small></p>
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="siteName" disabled>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete
                                        ref="autocomplete"
                                        placeholder="Search Site"
                                        :source="siteEndpoint"
                                        input-class="form-control"
                                        results-property="data"
                                        :results-display="formattedDisplay"
                                        :request-headers="authHeaders"
                                        @selected="getSite"
                                        :disableInput='isSiteDisabled'>
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>
                        <base-input label="Salesman">
                            <div class="form-group row">
                                <div class="col-sm-6">
                                    <input type="text" class="form-control" v-model="salesmanName" disabled>
                                </div>
                                <div class="col-sm-6">
                                    <autocomplete
                                        ref="autocomplete"
                                        placeholder="Search Salesman"
                                        :source="salesmanEndpoint"
                                        input-class="form-control"
                                        results-property="data"
                                        :results-display="formattedDisplay"
                                        :request-headers="authHeaders"
                                        @selected="getSalesman">
                                    </autocomplete>
                                </div>
                            </div>
                        </base-input>            
                        <base-input alternative="" label="Description">
                            <textarea rows="4" class="form-control" v-model="inputDescription"/>
                        </base-input>
                        <base-input alternative="" label="Tags">
                            <textarea rows="4" class="form-control" v-model="inputTags"/>
                        </base-input>
                    </a-tab-pane>
                    <a-tab-pane tab="Custom Fields" key="2" forceRender>
                        <dynamic-form :convertedJson="{mode: customForm.mode, groups: customForm.groups_append}" :formSettings="sublocation" @valueUpdated="updateSettings" :key="dynamicFormKey" :showErrors="false"/>
                    </a-tab-pane>
                </a-tabs>
            </div>

            <div v-if="this.$attrs.viewMode != true">
                <div v-if="serverType == 'ho'" style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Add</button>
                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button>
                </div> 
                <div v-else style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button>
                </div> 
            </div>
        </form>
    </div>
</template>

<script>
import HTTPRequest from '../../controllers/httpRequest.js'
import DynamicForm from '../DynamicForm.vue'
import ValidateField from '../../components/validateFormUtils.js'
import secureStorage from '../../controllers/secureStorage.js'
import { mapState } from 'vuex'
import Autocomplete from 'vuejs-auto-complete'
import moment from 'moment'

var component_x;  
export default {
    components: {
        Autocomplete, DynamicForm
    },
    computed: {
        ...mapState(['endPoint', 'profileId', 'serverType']),
    },
    mounted: async function() {
        // Meta-data Call
        const sytemModule = await HTTPRequest.getRequest(this.endPoint + 'system_modules/Sublocation?field_name=name'  , null)
        const sytemModuleId = sytemModule.id
        const accSystemModuleRequest = await HTTPRequest.getRequest(this.endPoint + 'account_system_modules/' + sytemModuleId + '?field_name=system_module_id'  , null)
        if(this.isJsonString(accSystemModuleRequest.meta) == true){ 
            const accSystemModule = JSON.parse(accSystemModuleRequest.meta)
            if(accSystemModule != null){
                if(accSystemModule.form_mode != undefined){
                    this.customFormMode = accSystemModule.form_mode
                }
                if(accSystemModule.customized_forms != undefined){
                    this.customForm = accSystemModule.customized_forms
                }
            }
        }

        if(this.serverType == 'branch' || this.$attrs.viewMode == true){
            var form = document.getElementById("form-proper")
            var elements = form.elements;
            for (var i = 0, len = elements.length; i < len; ++i) {
                elements[i].disabled = true;
            }
        }
        component_x = this
        if( component_x.profileId > 0){
            var data = await HTTPRequest.getRequest(component_x.endPoint + 'sublocations/' + component_x.profileId, null)    
            if(data == undefined){
                component_x.$router.go()
            } else {
                if(data["error"] == undefined){
                    component_x.inputCode = data["code"]
                    component_x.inputName = data["name"]
                    component_x.inputSublocationType = data["sublocation_type"]
                    component_x.inputSite = data["site_id"]
                    component_x.siteName = data["site_name"]
                    component_x.inputSalesman = data["salesman_id"]
                    component_x.salesmanName = data["salesman_name"]
                    component_x.inputDescription = data["description"]
                    component_x.inputTags = data["tags"]
                    component_x.inputCreatedBy = data["created_by"]
                    component_x.inputCreatedAt = data["created_at"]
                    component_x.inputUpdatedBy = data["updated_by"]
                    component_x.inputUpdatedAt = data["updated_at"]
                    component_x.sublocation = data
                    component_x.defaultSiteSublocation = data["default_site_sublocation"]
                    if (component_x.defaultSiteSublocation != ''){
                        component_x.isSiteDisabled = true
                    } 
                } else {
                    this.errors = data["error"].split(",") //format will change when error message has comma
                    //component_x.$router.push("/")
                }
            } 
        } 
        this.dynamicFormKey++;
    },
    data: function(){
        return {
            inputCode: '',
            inputName: '',
            errors: [],
            inputCreatedBy: '',
            inputCreatedAt: '',
            inputUpdatedBy: '',
            inputUpdatedAt: '',
            showDetails: true,
            // FOR META-DATA
            customFormMode: 1,
            customForm: {},
            profileData: {},
            dynamicFormKey: 0,
            sublocation: {},
            formErrors: [],

            authHeaders: { Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web", 'ip':secureStorage.getItem("ipAddress") },
            siteName: '',
            inputSite: '',
            inputSublocationType: '',
            sublocationTypeOptions: [
                {key: null, value: null},
                {key: "T", value: "Truck"},
                {key: "S", value: "Store-front"},
                {key: "B", value: "Backroom"}
            ],
            salesmanName: '',
            inputSalesman: '',
            inputDescription: '',
            inputTags: '',
            defaultSiteSublocation: '',
            isSiteDisabled: false

        }
    },
    filters: {
        dateFilter: function (timestamp) {
            return moment(timestamp).format('L LTS')
        }
    },
    methods: {
            updateSettings(newFormSettings, settingsGrouping, errors){
            var formSettingsCopy = this.sublocation
            var mergedHash = Object.assign({}, formSettingsCopy, newFormSettings);
            this.formErrors = errors

            if(this.customFormMode == 3) {
                this.errors = errors
            }

            this.sublocation = mergedHash
        },
        isJsonString(str) {
            try {
                var json = JSON.parse(str);
                return (typeof json === 'object');
            } catch (e) {
                return false;
            }
        },
        openDetails() {
            this.showDetails = true
        },
        openHistory() {
            this.showDetails = false
        },
        siteEndpoint (input) {
            return this.endPoint + '/sites?name=' + input;
        },
        getSite (group) {
            this.siteName = group.display;
            this.inputSite = group.value;
        },
        salesmanEndpoint (input) {
            return this.endPoint + '/salesmen?name=' + input;
        },
        getSalesman (group) {
            this.salesmanName = group.display;
            this.inputSalesman = group.value;
        },
        formattedDisplay (result) {
          return result.name + ' [' + result.code + ']';
        },
        validateForm(){
            this.errors = [];
            // this.errors.push(ValidateField.required('Code', this.inputCode));
            this.errors.push(ValidateField.required('Name', this.inputName));
            this.errors.push(ValidateField.required('Site', this.inputSite));
            this.errors.push(ValidateField.alphanumericWithSpace('Description', this.inputDescription));
            this.errors.push(ValidateField.alphanumericWithSpace('Tags', this.inputTags));
            this.errors = this._.compact(this.errors);
            document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
            return this.errors.length;
        },
        create: async function() {
            if(!this.validateForm()) {
                var sublocationPayload = {sublocation: {name: this.inputName.trim(), code: this.inputCode.trim(), 
                                                sublocation_type: this.inputSublocationType, site_id: this.inputSite,
                                                salesman_id: this.inputSalesman, description: this.inputDescription,
                                                tags: this.inputTags}
                                    }
                var sublocationPayloadMerged = Object.assign({}, this.sublocation, sublocationPayload.sublocation);
                var post_request = await HTTPRequest.postRequest(this.endPoint + 'sublocations/', null, sublocationPayloadMerged)    
                if(post_request == undefined){
                    this.$emit('refreshPage', event)
                } else {
                    if(post_request["error"] == undefined){
                        this.$emit('refreshPage', event)
                    } else {
                        this.errors = post_request["error"].split(",") //format will change when error message has comma
                        //this.$router.push("/")
                    }
                }
            }
        },
        update: async function(){
            if(!this.validateForm()) {
                var sublocationPayload = {sublocation: {name: this.inputName.trim(), code: this.inputCode.trim(), 
                                                sublocation_type: this.inputSublocationType, site_id: this.inputSite,
                                                salesman_id: this.inputSalesman, description: this.inputDescription,
                                                tags: this.inputTags}
                                    }
                var sublocationPayloadMerged = Object.assign({}, this.sublocation, sublocationPayload.sublocation);
                var put_request = await HTTPRequest.putRequest(this.endPoint + 'sublocations/' + this.profileId, null, sublocationPayloadMerged) 
                if(put_request == undefined){
                    this.$emit('refreshPage', event)
                } else {
                    if(put_request["error"] == undefined){
                        this.$emit('refreshPage', event)
                    } else {
                        this.errors = put_request["error"].split(",") //format will change when error message has comma
                        //this.$router.push("/")
                    }
                }
            }
        }
    }
}
</script>

<style>
</style>
